import { z } from "zod";
import {
  REFERRAL_ATTRIBUTION_STATUS,
  REFERRAL_BLOCKED_REASON,
  REFERRAL_REWARD_STATUS,
  REFERRAL_REWARD_TYPE,
} from "@artha/types";

export const ReferralClickRequestSchema = z.object({
  creatorUniqueId: z.string().min(1),
  attributionToken: z.string().optional(),
  visitorId: z.string().optional(),
});

export const ReferralPublicInviteParamsSchema = z.object({
  creatorUniqueId: z.string().min(1),
});

export const ReferralClickResponseSchema = z.object({
  attributionToken: z.string(),
  creatorUniqueId: z.string(),
  expiresAt: z.string().datetime(),
});

export const ReferralClaimRequestSchema = z.object({
  attributionToken: z.string().min(1),
});

export const ReferralClaimResponseSchema = z.object({
  claimed: z.boolean(),
  status: z.enum(Object.values(REFERRAL_ATTRIBUTION_STATUS) as [string, ...string[]]).optional(),
  blockedReason: z.enum(Object.values(REFERRAL_BLOCKED_REASON) as [string, ...string[]]).optional(),
});

export const ReferralPublicCreatorResponseSchema = z.object({
  id: z.string(),
  displayName: z.string(),
  username: z.string(),
  avatarUrl: z.string().optional(),
  nicheTags: z.array(z.string()),
  nicheBlurb: z.string(),
  inviteUrl: z.string(),
  lifetimeClicks: z.number(),
  lifetimeApplications: z.number(),
});

export const ReferralRewardEntrySchema = z.object({
  id: z.string(),
  month: z.string(),
  type: z.enum(Object.values(REFERRAL_REWARD_TYPE) as [string, ...string[]]),
  baseRevenue: z.number(),
  rate: z.number(),
  amount: z.number(),
  status: z.enum(Object.values(REFERRAL_REWARD_STATUS) as [string, ...string[]]),
  referredCreatorName: z.string().optional(),
  createdAt: z.string().optional(),
});

export type ReferralClickRequestDto = z.infer<typeof ReferralClickRequestSchema>;
export type ReferralClickResponseDto = z.infer<typeof ReferralClickResponseSchema>;
export type ReferralClaimRequestDto = z.infer<typeof ReferralClaimRequestSchema>;
export type ReferralClaimResponseDto = z.infer<typeof ReferralClaimResponseSchema>;
export type ReferralPublicCreatorResponseDto = z.infer<typeof ReferralPublicCreatorResponseSchema>;
export type ReferralRewardEntryDto = z.infer<typeof ReferralRewardEntrySchema>;
export type ReferralPublicInviteParamsDto = z.infer<typeof ReferralPublicInviteParamsSchema>;
